import React from 'react';

import { QBox } from '@captivateiq/quotient';

import { ChatTab } from './ChatTab';
import { HistoryTab } from './HistoryTab';

import { useAIShellContext } from '../../AIShellContext';

export const TabsAIShell = () => {
  const { tabIndex } = useAIShellContext();

  return (
    <QBox
      sx={{
        backgroundColor: 'neutral.primary.white',
        height: 'calc(100% - 60px)',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <QBox sx={{ height: '100%', position: 'relative' }}>
        {tabIndex === 0 && (
          <QBox sx={{ height: '100%', padding: 0 }}>
            <ChatTab />
          </QBox>
        )}
        {tabIndex === 1 && (
          <QBox sx={{ height: '100%', padding: 0 }}>
            <HistoryTab />
          </QBox>
        )}
      </QBox>
    </QBox>
  );
};
